import ChalkingPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_chalking.png'
import Chalking2xPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_chalking@2x.png'
import ChalkingWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_chalking.webp'
import Chalking2xWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_chalking@2x.webp'
import CrackPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_crack.png'
import Crack2xPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_crack@2x.png'
import CrackWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_crack.webp'
import Crack2xWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_crack@2x.webp'
import PeelingPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_peeling.png'
import Peeling2xPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_peeling@2x.png'
import PeelingWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_peeling.webp'
import Peeling2xWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_peeling@2x.webp'
import FadingPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_fading.png'
import Fading2xPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_fading@2x.png'
import FadingWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_fading.webp'
import Fading2xWebPPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_deterioration_button_fading@2x.webp'

export const DETERIORATION_LIST = [
  {
    id: 1,
    imagePaths: {
      png: ChalkingPngPath,
      png2x: Chalking2xPngPath,
      webp: ChalkingWebPPath,
      webp2x: Chalking2xWebPPath,
    },
    text: 'チョーキングあり',
  },
  {
    id: 2,
    imageKeyName: 'crack',
    imagePaths: {
      png: CrackPngPath,
      png2x: Crack2xPngPath,
      webp: CrackWebPPath,
      webp2x: Crack2xWebPPath,
    },
    text: 'ひび割れあり',
  },
  {
    id: 3,
    imagePaths: {
      png: PeelingPngPath,
      png2x: Peeling2xPngPath,
      webp: PeelingWebPPath,
      webp2x: Peeling2xWebPPath,
    },
    text: 'はがれあり',
  },
  {
    id: 4,
    imagePaths: {
      png: FadingPngPath,
      png2x: Fading2xPngPath,
      webp: FadingWebPPath,
      webp2x: Fading2xWebPPath,
    },
    text: '汚れ・くすみあり',
  },
];
